<template>
	<!-- 主体 -->
	<div class="bgView" :style="{fontSize:fontsize,width:screenWidth}" id="areaCockpit">
		<!-- 主体left -->
		<div class="bg" :style="{fontSize:fontsize,width:screenWidth}">

			<div :style="{width:viewWidth,height:viewHeight}" style="position: relative; display: flex;">
<!-- 				<div style="display: flex; width: 75%; justify-content: space-between; position: absolute;height: 100%;align-items: center;padding-top: 6em; padding: 6em 2em 0 2em; background-color: red;" >
					<div style="width: 4.5em; height: 4.5em;background: rgba(0, 0, 0, 0.5);">
						<div style="text-align: center;color: red;height: 4.5em;line-height: 4.5em;">
							
							
						</div>
					</div>
					<div style="width: 4.5em; height: 4.5em;background: rgba(0, 0, 0, 0.5);">
						<div style="text-align: center;color: red;height: 4.5em;line-height: 4.5em;">
							
							
						</div>
					</div>
				</div> -->
				
				<!-- <transition name="moveR"> -->
		
				<div style="color: red;width: 75%;height: 100%;"class="flipTheAnimation" v-if="animationSwitch">
					
					<div class="biaoti">
						<div class="biaoti-search">
							<div class="biaoti-search-i">
								<input
									@keyup.enter="keyup_submit"
									style="width:90%;padding-left: 1.25em;height:75%;outline: none;color: #fff;font-size: 1.3em;"
									v-model="queryInputValue" type="text" placeholder="请输入关键词" >
								<div class="biaoti-search-i-icon" @click="functionsa()"></div>
							</div>
							<!-- <div style=" background-color: #000000;" v-show="queryInputSwitch">
								<ul>
									<li v-for="(item,index) in this.searchData.list" style="list-style: none;height: 3em;line-height: 3em;font-size: 1.2em;color: #fff;cursor: pointer;">{{item.businessName}}</li>
									

								</ul>

							</div> -->
						</div>

					</div>
					<div style="width: 100%; height: 90%;display: flex;flex-wrap: wrap;padding-left: 3%;padding-top: 4%;position: relative;">
						<div style="position: absolute; left: 1%;width: 4.5em;height: 4.5em;background: rgba(0, 0, 0, 0.7);text-align: center;top: 45%;" @click="theLeftButton" @mouseover="mouseover" @mouseleave="mouseLeave">
							<div class="sanjiaoLeft">
								
							</div>
						</div>
						<div style="position: absolute; right: 1%;width: 4.5em;height: 4.5em;background: rgba(0, 0, 0, 0.7);text-align: center;top: 45%;"  @click="theRightButton" @mouseover="mouseover" @mouseleave="mouseLeave">
							<div class="sanjiaoRight"></div>
						</div>
						<div v-for="item in this.listDate.list"
							:class="[item.isWarning?'bgView-left-item':'bgView-left-item-1',!item.isOnLine?'bgView-left-item-2':'']">
							<div
								:class="[item.isWarning?'bgView-left-item-img':'bgView-left-item-img-1',!item.isOnLine?'bgView-left-item-img-2':'']">
								<div style="margin-left: 9%; font-size: 1.3em;color: #fff;">{{item.businessName}}</div>
								<div style="margin-right: 0.5%; font-size: 1.3em;color: #fff;display: flex;">
									<div class="bgView-left-item-img-utin">{{item.isOnLine?'在线':'离线'}}</div>
								</div>
							</div>
							<!-- 第二 -->
							<div style="width: 100%;height: 88%;padding: 1em;">
								<div style="width: 100%;height: 22%;display: flex; ">
									<div
										:class="[item.isWarning?'bgView-left-item-Content-T-img':'bgView-left-item-Content-T-img-1',!item.isOnLine?'bgView-left-item-Content-T-img-2':'']">
									</div>
									<div class="bgView-left-item-Content-T-wendu" style="margin-top: 0.24rem;">
										<div style="display: flex;justify-content: space-between;align-items: center;">
											<div style="padding-top: 1%;">
												<div
													style="font-size:1.4em;font-family: PingFang HK;font-style: normal;font-weight: 600;">
													温度</div>
												<div style="font-size:1em;display: flex;font-family: PingFang HK;">
													<p>正常范围</p>

													<p style="color:#18FEFE;">
														[{{item.temperatureWarnValueLow}}°C-{{item.temperatureWarnValueHigh}}°C]
														<!-- [{{item.temperatureWarnValueHigh}}°C{{item.temperatureWarnValueLow}}°C] -->
														<!-- {{[item.temperatureWarnValueHigh+"°C-"+item.temperatureWarnValueLow+"°C"]}} -->
													</p>
												</div>
											</div>
											<div style="border: 0.1em solid #FF8A00;width: 4em;height: 2.7em;margin-top: 0.24rem;display: flex; flex-direction: column;padding-top: 0.29em;"
												v-if="item.isWarning === true">
												<div
													style="border: 0.01em solid #FF8A00; transform: rotate(31.85deg);width: 1em;align-self: flex-start;">
												</div>
												<div
													style="font-size:1em;color:#FF8A00;font-weight: 600;align-self: center;">
													告警
												</div>
												<div
													style="border: 0.01em solid #FF8A00; transform: rotate(31.85deg);width: 1em;align-self: flex-end;">
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- 第三 -->
								<div
									style="display: flex;width: 100%;justify-content: space-between;height: 20%;margin-top: 4%;">
									<!-- 第一种状态 -->
									<div v-for="itemTemperatureDataList in item.temperatureDataList"
										:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring':'bgView-left-item-T-monitoring-1',!item.isOnLine?'bgView-left-item-T-monitoring-2':'']"
										v-if="item.temperatureDataList.length===1">


										<div class="bgView-left-item-T-monitoring-div" @click="jumpQuery(itemTemperatureDataList.collectorId,itemTemperatureDataList.collectPlace)">
											<div
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-num':'bgView-left-item-T-monitoring-div-num-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-num-2':'']">
												{{itemTemperatureDataList.collectValue+"°C"}}
											</div>
											<div class="bgView-left-item-T-monitoring-div-title"
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-title':'bgView-left-item-T-monitoring-div-title-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-title-2':'']">
												{{itemTemperatureDataList.collectPlace}}
											</div>
										</div>

									</div>
									<!-- 第二种状态 -->
									<div v-for="itemTemperatureDataList in item.temperatureDataList"
										class="bgView-left-item-T-monitoring-three"
										:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-three':'bgView-left-item-T-monitoring-three-1',!item.isOnLine?'bgView-left-item-T-monitoring-three-2':'']"
										v-if="item.temperatureDataList.length===2"
										@click="jumpQuery(itemTemperatureDataList.collectorId,itemTemperatureDataList.collectPlace)"
										>

										<div class="bgView-left-item-T-monitoring-div" style="margin-top: 5%;">
											<div
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-num':'bgView-left-item-T-monitoring-div-num-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-num-2':'']">
												{{itemTemperatureDataList.collectValue+"°C"}}
											</div>
											<div class="bgView-left-item-T-monitoring-div-title"
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-title':'bgView-left-item-T-monitoring-div-title-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-title-2':'']">
												{{itemTemperatureDataList.collectPlace}}
											</div>
										</div>


									</div>
									<!-- 第三种状态 -->
									<!--  -->
									<div v-for="itemTemperatureDataList in item.temperatureDataList"
										class="bgView-left-item-T-monitoring-three"
										:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-three':'bgView-left-item-T-monitoring-three-1',!item.isOnLine?'bgView-left-item-T-monitoring-three-2':'']"
										v-if="item.temperatureDataList.length===3"
									   @click="jumpQuery(itemTemperatureDataList.collectorId,itemTemperatureDataList.collectPlace)"
										>

										<div class="bgView-left-item-T-monitoring-div" style="margin-top: 5%;">
											<div
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-num':'bgView-left-item-T-monitoring-div-num-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-num-2':'']">
												{{itemTemperatureDataList.collectValue+"°C"}}
											</div>
											<div class="bgView-left-item-T-monitoring-div-title"
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-title':'bgView-left-item-T-monitoring-div-title-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-title-2':'']">
												{{itemTemperatureDataList.collectPlace}}
											</div>
										</div>


									</div>


								</div>

								<!-- 第四 -->
								<div style="width: 100%;height: 22%;display: flex;margin-top: 4%;">
									<div
										:class="[item.isWarning?'bgView-left-item-Content-T-img':'bgView-left-item-Content-T-img-1',!item.isOnLine?'bgView-left-item-Content-T-img-2':'']">
									</div>
									<div class="bgView-left-item-Content-T-wendu" style="margin-top: 0.24rem;">
										<div style="display: flex;justify-content: space-between;align-items: center;">
											<div style="padding-top: 1%;">
												<div
													style="font-size:1.4em;font-family: PingFang HK;font-style: normal;font-weight: 600;">
													湿度</div>
												<div style="font-size:1em;display: flex;font-family: PingFang HK;">
													<p>正常范围</p>

													<p style="color:#18FEFE;">
														<!-- {{[item.humidityWarnValueHigh+"%RH-"+item.humidityWarnValueLow+"%RH"]}} -->
														[{{item.humidityWarnValueLow}}%RH-{{item.humidityWarnValueHigh}}%RH]
													</p>
												</div>
											</div>

										</div>
									</div>
								</div>
								<div
									style="display: flex;width: 100%;justify-content: space-between;height: 22%;margin-top: 4%;">
									<!-- 第一种状态 -->
									<div v-for="itemTemperatureDataList in item.humidityDataList"
										:class="[item.isWarning?'bgView-left-item-T-monitoring':'bgView-left-item-T-monitoring-1',!item.isOnLine?'bgView-left-item-T-monitoring-2':'']"
										v-if="item.humidityDataList.length===1"
										@click="jumpQuery(itemTemperatureDataList.collectorId,itemTemperatureDataList.collectPlace)"
										
										>


										<div class="bgView-left-item-T-monitoring-div">
											<div
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-num':'bgView-left-item-T-monitoring-div-num-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-num-2':'']">
												{{itemTemperatureDataList.collectValue+"%RH"}}
											</div>
											<div class="bgView-left-item-T-monitoring-div-title"
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-title':'bgView-left-item-T-monitoring-div-title-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-title-2':'']">
												{{itemTemperatureDataList.collectPlace}}
											</div>
										</div>

									</div>
									<!-- 第二种状态 -->
									<div v-for="itemTemperatureDataList in item.humidityDataList"
										class="bgView-left-item-T-monitoring-three"
										:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-three':'bgView-left-item-T-monitoring-three-1',!item.isOnLine?'bgView-left-item-T-monitoring-three-2':'']"
										v-if="item.humidityDataList.length===2"
										@click="jumpQuery(itemTemperatureDataList.collectorId,itemTemperatureDataList.collectPlace)"
										>

										<div class="bgView-left-item-T-monitoring-div">
											<div
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-num':'bgView-left-item-T-monitoring-div-num-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-num-2':'']">
												{{itemTemperatureDataList.collectValue+"%RH"}}
											</div>
											<div class="bgView-left-item-T-monitoring-div-title"
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-title':'bgView-left-item-T-monitoring-div-title-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-title-2':'']">
												{{itemTemperatureDataList.collectPlace}}
											</div>
										</div>


									</div>
									<!-- 第三种状态 -->
									<!--  -->
									<div v-for="itemTemperatureDataList in item.humidityDataList"
										class="bgView-left-item-T-monitoring-three"
										:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-three':'bgView-left-item-T-monitoring-three-1',!item.isOnLine?'bgView-left-item-T-monitoring-three-2':'']"
										v-if="item.humidityDataList.length===3"
										@click="jumpQuery(itemTemperatureDataList.collectorId,itemTemperatureDataList.collectPlace)"
										>

										<div class="bgView-left-item-T-monitoring-div" >
											<div
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-num':'bgView-left-item-T-monitoring-div-num-1',!item.isOnLine?'bgView-left-item-T-monitoring-div-num-2':'']">
												{{itemTemperatureDataList.collectValue+"%RH"}}
											</div>
											<div class="bgView-left-item-T-monitoring-div-title"
												:class="[itemTemperatureDataList.isWarning?'bgView-left-item-T-monitoring-div-title':'bgView-left-item-T-monitoring-div-title-1',item.isOnLine?'bgView-left-item-T-monitoring-div-title-2':'']">
												{{itemTemperatureDataList.collectPlace}}
											</div>
										</div>


									</div>


								</div>


							</div>
						</div>

					</div>
				</div>
			
			    <!-- </transition> -->
			
			
			
			
			
				<div style="width: 24%;background-color: red;margin-left: 1%;" class="flipTheAnimation" v-if="animationSwitch">
					<div class="bgView-right">
						<div class="bgView-right-item-img">
							<div
								style="margin-left: 9%;font-size: 1.5em;line-height: 0.8rem;font-family: PingFang HK;font-weight: 600;color: #fff;">
								警告记录
							</div>

						</div>
						<div style="margin: 1em 0;">
							<div style="display: flex;">
								<div
									style="display: flex;width:35%;text-align: center;height: 3em;line-height: 3em;font-size: 1em;color:rgba(255, 255, 255, 0.7);background-color:rgba(70, 70, 70, 0.35);">
									<div style="color: rgba(255, 255, 255, 0.7);flex: 1">设备位置</div>
									<div style="color: rgba(255, 255, 255, 0.7);width: 35%;">测量点</div>
								</div>
								<div
									style="display: flex;width: 64%;text-align: center;height: 3em;line-height: 3em;font-size: 1em;color:rgba(255, 255, 255, 0.7);background-color:rgba(145, 141, 141, 0.49);margin-left: 1%;">
									<div style="color: rgba(255, 255, 255, 1);flex: 1;">告警时间</div>
									<div style="color: rgba(255, 255, 255, 1);flex: 1;">告警时长</div>
								</div>
							</div>
							<div style="display: flex;" class="bgView-right-list-item" v-for="(warningDataItem,index) in this.listWarning.list"  @click="jumpQuery(warningDataItem.warningDataResponse.collectorId,warningDataItem.warningDataResponse.collectPlace)">
								<div
									style="display: flex;width: 35%;text-align: center;height: 3em;line-height: 3em;font-size: 1em;color:rgba(255, 255, 255, 0.7);">
									<div style="color: rgba(255, 255, 255, 0.6);flex: 1;">{{warningDataItem.warningDataResponse.businessName}}</div>
									<div style="color: rgba(255, 255, 255, 0.6););width: 35%;">{{warningDataItem.warningDataResponse.collectPlace}}</div>
								</div>
								<div
									style="display: flex;width: 64%;text-align: center;height: 3em;line-height: 4em;font-size: .8em;color:rgba(255, 255, 255, 0.7);margin-left: 0.1rem;">
									<div style="color: rgba(255, 255, 255, 0.6);width:50%;">{{warningDataItem.warningDataResponse.warningStartDateTime}}</div>
									<div style="color: rgba(255, 255, 255, 0.6);flex: 1;">{{warningDataItem.warningDataResponse.warningEndDateTime}}</div>
								</div>
								
							</div>
						</div>
						<div class="bgView-right-item-img" style="margin-top: 1em;">
							<div
								style="margin-left: 9%;font-size: 1.5em;line-height: 0.8rem;font-family: PingFang HK;font-weight: 600;color: #fff;">
								温湿度变化曲线
							</div>

						</div>
						
						<div style="width: 100%; height: 70%; margin-top: 2%;" >
							<div style="width: 100%; height: 30%;margin-top: 3%;" v-for="(warningDataItem,index) in this.listWarning.list">
								<div  class="bgView-right-item-img-s" style="color: red;">
									<div
										style="margin-left: 9%;font-size: 1.5em;line-height: 0.8rem;font-family: PingFang HK;font-weight: 600;color: #fff;display: flex;justify-content: space-between;width: 100%;padding-right: 3%;">
										<div>{{businessNameList[index]}}</div>
										<div>{{collectPlaceList[index]}}</div>
									</div>
								</div>
								<!-- :id="'echlesMain'+index" -->
								<!-- `echlesMain${index}` -->
								<div  class="gauge" :id="`echlesMain${index}`"></div>
							</div>
						
						
						
						</div>


					</div>
				</div>

			</div>
		</div>
	</div>


</template>
<script>
	import ZSourceSelector from '@/components/ZSourceSelector';
	import Vue from 'vue';
	import ZMenu from '@/components/ZMenu';
	import ZSetUp from '@/components/ZSetUp';
	import {
		thePharmacyWarning,
		thePharmacyInRealTime,
		fastmock
	} from '@/api/HMonLgScrn';
	    import {mapGetters} from 'vuex'
	export default {
		name: 'Tree',
		data() {
			return {
				// input 搜索
				queryInputValue: '',
				// input 搜索列表开关
				queryInputSwitch: false,
				textshow: '',
				viewWidth: '',
				viewHeight: '',
				screenWidth: '',
				fontsize: '',
				listDate: [],
				listWarning:[],
				pageSizeIndex:1,
				animationSwitch:true,
                xaixDate:[],
                yaixDate:[],
				// 搜索
				searchData:[],
				interval:null,
				yName:'',
				collectPlaceList:[],
				businessNameList:[],
				collectPlaceText:'',
				collectDataTypeList:[],
			};


		},
		components: {
			ZSourceSelector,
			ZMenu,
			ZSetUp
		},

		computed: {
			filter() {
				return (item, search, textKey) => item[textKey].indexOf(search) > -1 ? item : undefined;
			},
		},
		watch: {
			// 输入框监控
			// queryInputValue(newValue) {
			// 	if (newValue) {
				
			// 		this.textshow = newValue;
			// 		this.queryInputSwitch = true;
			// 	} else {
			// 		console.log('关闭输入框列表queryInputSwitch === false');
			// 		this.queryInputSwitch = false;
			// 	}


			// }
		},

		methods: {
            
			mouseLeave(){
				console.log('左出')
				this.initPage();
			},
			mouseover(){
				clearInterval(this.interval);
				console.log(this.pageSizeIndex)
			},
			 theLeftButton(){
				  clearInterval(this.interval);
				  console.log(this.pageSizeIndex)
				  if(this.pageSizeIndex === 1)
				  {			
				  	this.pageSizeIndex =2;
				  	this.thePharmacyInRealTime();	
				  	this.animationSwitch = true;
		
				  				
				  }else if(this.pageSizeIndex === 2){
				  				 // this.animationSwitch = false;
				  				 this.pageSizeIndex =1;
				  				 this.thePharmacyInRealTime();
				  				 this.animationSwitch = true;
				  				 
				  }
				 console.log("左点")
				 
			 },
			 theRightButton(){
				 clearInterval(this.interval);
				  console.log(this.pageSizeIndex)
				  if(this.pageSizeIndex === 1)
				  {			
				  	this.pageSizeIndex =2;
				  	this.thePharmacyInRealTime();	
				  	this.animationSwitch = true;
				 		
				  				
				  }else if(this.pageSizeIndex === 2){
				  				 // this.animationSwitch = false;
				  				 this.pageSizeIndex =1;
				  				 this.thePharmacyInRealTime();
				  				 this.animationSwitch = true;
				  				 
				  }
				 console.log("右点")
			 },
			 
			 keyup_submit(){
			 this.functionsa()
			 console.log('回车')
			  
			  },
	        functionsa(a){
				console.log('sdasd')
				if (this.queryInputValue) {
					console.log(this.queryInputValue);
					var rs = {
						pagedQueryInfo: {
							index: 1,
							pageSize: 6
						},
					 businessName: this.queryInputValue
					};
					
					thePharmacyInRealTime(rs).then(res => {
					     this.listDate = res;
						console.log(res, 'resresresresresres');
					}).catch(err => {
					
					});
					// console.log(this.listDate);
				}else{
					var rs = {
						pagedQueryInfo: {
							index: 1,
							pageSize: 6
						},
					 businessName: ""
					};
					
					thePharmacyInRealTime(rs).then(res => {
					     this.listDate = res;
						console.log(res, 'resresresresresres');
					}).catch(err => {
					
					});
				}
			},
		    setDate(index){
				return {
					tooltip: {
						
					        trigger: 'axis',
							 color: '#fff',
							 padding: [2, 10],
							 textStyle: {
							   fontSize: 16
							 },
							 axisPointer: {
							      type: 'line', //line: 直线指示器 shadow:阴影指示器 cross:十字准星指示器
							      lineStyle: { //axisPointer.type 为 'line' 时有效
							        color: {
							           type: 'linear', //linear:线性渐变  radial:径向渐变
							           x: 0,
							           y: 0,
							           x2: 0,
							           y2: 1,
							           colorStops: [{
							               offset: 0, // 0% 处的颜色
							               color: 'rgba(0, 255, 233,0)'
							               }, {
							               offset: 0.5,
							               color: 'rgba(255, 255, 255,1)',
							                }, {
							                offset: 1, // 100% 处的颜色
							                color: 'rgba(0, 255, 233,0)'
							           }],
							           global: false // 缺省为 false
							       },
								   }},
								   formatter: (params,) => {
									        var str = '';
											if(params[0].data.name === '02'){
												
												             str = `<div style="font-size:0.875rem;border-radius:0.2rem;margin:0 0.5rem;background-color:#;"><div>${params[0].axisValue}</div>
												             <div>湿度:${params[0].data.value}%RH</div>
												             <div>`
												             return str
												
											}else if(params[0].data.name === '01'){
												
												str = `<div style="font-size:0.875rem;border-radius:0.2rem;margin:0 0.5rem;background-color:#;"><div>${params[0].axisValue}</div>
												<div>温度:${params[0].data.value}°C</div>
												<div>`
												return str
											}
									
								                 }
							},
					xAxis: {
				
						type: 'category',
						boundaryGap: false,
						data: this.xaixDate,
						axisLabel: {
							textStyle: {
								color: 'rgba(179, 181, 183, 1)',
								fontSize:'9',
								
							},
							          interval:3,  
									  formatter: function (value) {
									    return value.split(" ")[0]+'\n'+value.split(" ")[1];
									  } 
							
							
						},
						axisLine: {
							lineStyle: {
								color: '#FFFFFF',
								width: 1, //这里是为了突出显示加上的  
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false //去掉折线图中的横线
						}
				
					},
					yAxis: {
						name: '单位'+this.yName ,
						nameTextStyle: {
							padding: [0, 0, 5, 10],
							color: 'rgba(179, 181, 183, 1)',
							// fontSize:'10'
						},
						type: 'value',
						axisLabel: {
							textStyle: {
								color: 'rgba(179, 181, 183, 1)'
							},
						},
						axisLine: {
							lineStyle: {
								color: '#FFFFFF',
								width: 1, //这里是为了突出显示加上的  
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false //去掉折线图中的横线
						}
				
					},
					series: [{
						data:this.yaixDate,
						showAllSymbol: true,
						type: 'line',
						// 设置小圆点消失
						// 注意：设置symbol: 'none'以后，拐点不存在了，设置拐点上显示数值无效
						symbol: 'none',
						// markLine: {
						//       symbol: ['none', 'none'],
						//       label: { show: false },
						//       data: [{ xAxis: 1 }, { xAxis: 3 }, { xAxis: 5 }, { xAxis: 7 }]
						//     },
						areaStyle: {
							color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(24, 89, 255, 0.32)'
								},
								{
									offset: 1,
									color: 'rgba(33, 228, 255, 0)'
								},
							])
						}, //填充区域样式
						lineStyle: {
							width: 4,
							color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(33, 228, 255, 1)'
								},
								{
									offset: 1,
									color: 'rgba(0, 100, 251, 1)'
								},
							])
						}
				
					}],
			        
			
			
				}
				
			},
			resizePage() {
				var x = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				var y = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
				console.log(x, '宽');
				console.log(y, '高');
				this.screenWidth = x + 'px';
				var val = parseFloat((x / y).toFixed(1));
				console.log(val, '比例');
				if (val < 1.78) {
					console.log('宽为准');
					// 以宽为准
					this.viewWidth = x + 'px';
					this.viewHeight = parseInt(x / (1.78)) + 'px';
					this.fontsize = parseInt(x / (1920 / 16)) + 'px';
				} else {
					console.log('高为准');
					// 以高为准
					this.viewHeight = '100%';
					this.viewWidth = parseInt(y * 1.77) + 'px';
					this.fontsize = parseInt((y * 1.77) / (1920 / 16)) + 'px';
				}
				this.viewWidth = x + 'px';
				this.viewHeight = y + 'px';
				 // this.animationSwitch = false;
				this.$nextTick(() => {
					console.log('执行')
				 this.initPage();
				});
			},
		
		     // 日期格式化
		     dateFormat(fmt, date) {
		        let ret;
		        const opt = {
		            'Y+': date.getFullYear().toString(), // 年
		            'm+': (date.getMonth() + 1).toString(), // 月
		            'd+': date.getDate().toString(), // 日
		            'H+': date.getHours().toString(), // 时
		            'M+': date.getMinutes().toString(), // 分
		            'S+': date.getSeconds().toString() // 秒
		            // 有其他格式化字符需求可以继续添加，必须转化成字符串
		        };
		        for (let k in opt) {
		            ret = new RegExp('(' + k + ')').exec(fmt);
		            if (ret) {
		                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')));
		            };
		        };
		        return fmt;
		    },
			jumpQuery(collectorId,collectPlace){
				
				const stamp1 = new Date(new Date().setHours(0, 0, 0, 0));
				const stamp2 = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
				console.log(this.dateFormat('YYYY-mm-dd HH:MM', stamp1));
				console.log(this.dateFormat('YYYY-mm-dd HH:MM', stamp2));
				console.log(collectorId,collectPlace);
				this.$router.push({path: '/history-data',
				query:{
					// 显示下一步过后页面
					stepValue:2,
					collectorId:collectorId,
					collectPlace:collectPlace,
					startTime:this.dateFormat('YYYY-mm-dd HH:MM', stamp1),
					endTime:this.dateFormat('YYYY-mm-dd HH:MM', stamp2)
				}
				});
			},
			thePharmacyInRealTime() {
			
				var rs = {
					pagedQueryInfo: {
						index: this.pageSizeIndex,
						pageSize: 6
					}
				};
               // this.animationSwitch = false;
				thePharmacyInRealTime(rs).then(res => {
					// this.animationSwitch = true;
					this.listDate = res;
				}).catch(err => {

				});
			},
			thePharmacyWarning() {
			
				var rs = {
					pagedQueryInfo: {
						index: this.pageSizeIndex,
					   pageSize: 3
					}
				};
				// this.animationSwitch = false;
				thePharmacyWarning(rs).then(res => {
					// this.animationSwitch = true;
					this.listWarning = res;
				}).catch(err => {
			
				});
			},
		
			
			
		
        initPage() {
      			var _this = this;
      			 // this.animationSwitch = true;
      		    console.log(this.animationSwitch)
      			this.thePharmacyInRealTime();
      			this.thePharmacyWarning();
      
                  clearInterval(this.interval);
      			// this.animationSwitch = true;
      			 console.log(this.animationSwitch)
      			 this.theLineChart();
                  this.interval=setInterval(() => {
      			 if(_this.pageSizeIndex === 1)
      			 {			
      				_this.pageSizeIndex =2;
      				_this.thePharmacyInRealTime();
      				_this.thePharmacyWarning();			
      				_this.theLineChart();
      				_this.animationSwitch = true;
      				
      				
      			 }else if(_this.pageSizeIndex === 2){
      				 // this.animationSwitch = false;
      				 _this.pageSizeIndex =1;
      				 // this.theLineChart();
      				 _this.thePharmacyInRealTime();
      				 _this.thePharmacyWarning();
      				 _this.theLineChart();
      				 _this.animationSwitch = true;
      				 console.log(_this.pageSizeIndex);
      				 
      			 }
                  
      			 
                  },15000);
              },

        theLineChart() {
			var _this= this;
			this.collectPlaceList = [];
			this.businessNameList = [];
			console.log(this.listWarning.list,"this.listWarning.listthis.listWarning.listthis.listWarning.listthis.listWarning.list")
	
            this.listWarning.list.forEach((val,index)=>{
			console.log(val.warningChartResponse.collectPlace);
			_this.collectPlaceText = val.warningChartResponse.collectPlace
			console.log(_this.collectPlaceText);
			_this.collectPlaceList.push(val.warningChartResponse.collectPlace)
			_this.businessNameList.push(val.warningChartResponse.businessName)
			_this.collectDataTypeList.push(val.warningChartResponse.collectDataType)
			if (val.warningChartResponse.collectDataType === '01') {
				_this.yName = ':°C';
				
				console.log(_this.yName);
			
			} else if(val.warningChartResponse.collectDataType === '02'){
				_this.yName = ':%RH';
				
				console.log(_this.yName);
			}
			
	    	this.xaixDate=[];
			this.yaixDate=[];
        	let eqpChart = this.$echarts.init(document.getElementById('echlesMain'+index), 'macarons');
        	for (let i = 0; i < val.warningChartResponse.drugstoreChartDataList.length; i++) {
        		_this.xaixDate.push(val.warningChartResponse.drugstoreChartDataList[i].chartDate);
        		_this.yaixDate.push({value:val.warningChartResponse.drugstoreChartDataList[i].chartValue,name:val.warningChartResponse.collectDataType});
        	}
        	eqpChart.setOption(_this.setDate(index));
        	eqpChart.resize();
        });
         console.log(this.collectPlaceText,'this.collectPlaceText')
        },
		},

	  async mounted() {
		
			console.log('初始化成功');
			
		    this.thePharmacyWarning();
			
			
			 window.onresize = () => {
				return (() => {
					var elem = document.getElementById('areaCockpit');
					if (!elem) {

					} else {
						console.log('屏幕变化大小');
						this.resizePage();
					}
				})();
			};
			this.resizePage();
			var rq = {
				pagedQueryInfo: {
					index: this.pageSizeIndex,
				   pageSize: 3
				}
			};
			var _this= this;
			var rrq =await thePharmacyWarning(rq);
			// console.log(rrq,'rrqrrqrrqrrqrrq');
			 this.listWarning = rrq;
			// console.log('结束请求');
			// console.log(this.listWarning.list,);
			this.$nextTick(function(){
				this.theLineChart();
			})
	      
		},
		

		
		created() {
			console.log('进入成功');
		},
		
	   destroyed() {
	       console.log("=========================清除计时器=====================");
	       clearInterval(this.interval);
	   },
		beforeDestroy(){
			clearInterval(this.interval);
		}

      
	};
</script>

<style scoped >
	@import '../../style/animate.min.css';
	/* 主体 */


	.bgView {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background-size: cover;
		background-position: center;


	}

	.bg {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background: url(img/bg.png) no-repeat;
		background-size: 76% 100%;
		/* background-position: left; */
	}

    
	/* 主体left */
	.bgView-left {
		width: 76%;
		/* height:100%; */
	}

	/* 主体标题 */
	.biaoti {
		width: 100%;
		height: 10%;
		background: url(img/biaoti.png);
		background-size: 100% 100%;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		position: relative;

	}

	/* 主体搜索 */
	.biaoti-search {
		position: absolute;
		right: 2%;
		width: 20%;
		height: 50%;
		background: url(img/ss_bg.png) no-repeat;
		background-size: 100% 100%;

	}

	.biaoti-search-i {
		width: 100%;
		height: 100%;
	
		display: flex;
		display: -webkit-flex;
		align-items: center;
		justify-content: space-between;
	}

	/* 主体搜索 放大镜icon图标*/
	.biaoti .biaoti-search .biaoti-search-i-icon {
		margin-right: 1.5em;
		width: 1.2em;
		height: 1.2em;
		background: url(img/ss.png) no-repeat;
		background-size: cover;
		cursor: pointer;

	}

	/* 主体left-内容 */
	.bgView .bgView-left .content {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	/* 黄色*/
	.bgView-left-item {
		width: 30%;
		height: 47%;
		background: url(img/yjcd_bg.png) no-repeat;
		/* background: url(img/zccp_bg.png) no-repeat; */
		background-size: 100% 100%;
		margin-right: 3%;
	}

	/* 蓝色 */
	.bgView-left-item-1 {
		width: 30%;
		height: 47%;
		background: url(./img/zccp_bg.png) no-repeat;
		background-size: 100% 100%;
		margin-right: 3%;

	}

	/* 灰色 */
	.bgView-left-item-2 {
		width: 30%;
		height: 47%;
		background: url(img/lx_bg.png) no-repeat;
		background-size: 100% 100%;
		margin-right: 3%;

	}

	/* 黄色*/
	.bgView-left-item .bgView-left-item-img {
		background: url(img/yjbt_zs.png) no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 12%;
		display: flex;
		font-size: 0.875em;
		align-items: center;
		justify-content: space-between;

	}

	/* 蓝色 */
	.bgView-left-item-1 .bgView-left-item-img-1 {
		width: 100%;
		height: 12%;
		background: url(img/zcbt_zs.png) no-repeat;
		background-size: 100% 100%;
		background-position: center;
		display: flex;
		font-size: 0.875em;
		align-items: center;
		justify-content: space-between;

	}

	/* 灰色 */
	.bgView-left-item-2 .bgView-left-item-img-2 {
		background: url(./img/btzs_lx.png) no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 12%;
		display: flex;
		font-size: 0.875em;
		align-items: center;
		justify-content: space-between;

	}

	.bgView-left-item-Content-T-img {

		background: url(img/zq.png) no-repeat;
	background-size: contain;
	height: 100%;
	width:0; 
	padding-left: 20%;
	overflow: hidden;
	}

	.bgView-left-item-Content-T-img-1 {
		background: url(img/zq2.png) no-repeat;
		background-size: contain;
		height: 100%;
		width:0; 
		padding-left: 20%;
		overflow: hidden;
	}

	.bgView-left-item-Content-T-img-2 {
		background: url(img/zq_lx.png) no-repeat;
		background-size: contain;
		height: 100%;
		width:0; 
		padding-left: 20%;
		overflow: hidden;
		
		
	}




	.bgView-left-item-Content-T-wendu {
		width: 79%;
		height: 100%;
		padding-left: 1em;
		color: #fff;

	}


	.bgView-left-item-T-monitoring {
		background: url(./img/lQLPDhq147tMH6LMw80EvLAYqyZEUGe-GZ9qWaJyY2ec_1212_195.png) no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 100%;
		cursor: pointer;
	}

	.bgView-left-item-T-monitoring-1 {
		background: url(img/lQLPDhq147tMH6HMw80EvLCKw5N6K7DpJNf4uIrwj6Mu_1212_195.png) no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 100%;
		cursor: pointer;
	}

	.bgView-left-item-T-monitoring-2 {
		background: url(img/wd_bg.png)no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 100%;
		cursor: pointer;
	}

	.bgView-left-item-T-monitoring-three {
		background: url(img/wd_bk_xiao.png) no-repeat;
		background-size: 100% 100%;
		margin: 0 0.5em;
		flex: 1;
		cursor: pointer;
	}

	.bgView-left-item-T-monitoring-three-1 {
		background: url(img/wd_bg_xiao2.png);
		background-size: 100% 100%;
		margin: 0 0.5em;
		flex: 1;
		cursor: pointer;
	}

	.bgView-left-item-T-monitoring-three-2 {
		background: url(img/wd_bg_xiao2.png);
		background-size: 100% 100%;
		margin: 0 0.5em;
		flex: 1;
		cursor: pointer;
	}

	.bgView-left-item-T-monitoring-div {
		margin-top: 2%;
		text-align: center;

	}

	.bgView-left-item-T-monitoring-div-num {
		color: #FF8A00;
		font-size: 1.5em;
	}

	.bgView-left-item-T-monitoring-div-num-1 {
		color: #18FEFE;
		font-size: 1.5em
	}

	.bgView-left-item-T-monitoring-div-num-2 {
		color: #FFFFFF;
		font-size: 1.5em
	}

	.bgView-left-item-T-monitoring-div-title {
		color: #fff;
		font-size: 0.8em;
	}

	.bgView-left-item-T-monitoring-div-title-1 {
		color: #fff;
		font-size: 0.8em;
	}

	.bgView-left-item-T-monitoring-div-title-2 {
		color: #fff;
		font-size: 0.8em;
	}



	/* 主体right */
	.bgView-right {
		width: 100%;
		height: 100%;
		background: url(./img/bg2.png)no-repeat;
		background-size: 100% 100%;
		padding: 2em 2em;

	}

	.bgView-right .bgView-right-item-img {

		background: url(img/kjjl_bg.png)no-repeat;
		background-color: rgba(0, 0, 0, 0.4);
		background-size: 100% 100%;
		width: 100%;
		height: 5%;
		display: flex;
		font-size: 0.8em;
		align-items: center;
		justify-content: space-between;
	}
	.bgView-right .bgView-right-item-img-s {
	    /* background: url(img/btzs_lx.png) no-repeat; */
		background: url(img/lQLPDhq5HTPRGknMhM0E77CgwBd59f8h_AB_FbyspjyN_1263_132.png);
		background-color: rgba(0, 0, 0, 0.4);
		background-size: 100% 100%;
		width: 100%;
		height: 20%;
		display: flex;
		font-size: 0.8em;
		align-items: center;
		justify-content: space-between;
		color: #000088;
	}

	.bgView-right .bgView-right-item-img-item {
		background: url(img/kjjl_bg.png)no-repeat;
		background-color: rgba(0, 0, 0, 0.4);
		background-size: 100% 100%;
		width: 100%;
		height: 2.5rem;
		display: flex;
		font-size: 0.8rem;
		align-items: center;
		justify-content: space-between;
	}
	.gauge {
		width: 100%;
		height: 100%;
	}

	/* input 输入框 placeholder  文字修改 */

	.biaoti-search input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #ffffff;
	}

	.biaoti-search input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #ffffff;
	}

	.biaoti-search input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #ffffff;
	}

	.biaoti-search input:-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #ffffff;
	}

	/*  */
	.bgView-right-list-item:hover {
		border: 0.0625rem solid #18FEFE;
		cursor: pointer;
	}

	.bgView-left-item-img-utin {
		font-size: 0.8em;
		border: 0.1em solid #FFFFFF;
		border-radius: 2px;
		box-sizing: border-box;
		padding: 0 0.6em;
		margin-right: 0.5em;
	}
	
  .flipTheAnimation{
       animation: toShow 1s 0.5s;
       animation: toShow 1s 0.5s;
       animation-fill-mode: both !important;
       -webkit-animation-fill-mode: both !important;
  }
	
	@keyframes toShow {
	    0% {opacity: 0;}
	    100% {opacity: 1;}
	}
	@-webkit-keyframes toShow {
	    0% {opacity: 0;}
	    100% {opacity: 1;}
	}
	
	
	 .moveL-enter-active,
	     .moveL-leave-active {
	         transition: all 0.3s linear;
	         transform: translateX(0%);
	     }
	    .moveL-enter,
	    .moveL-leave {
	        transform: translateX(-100%);
	    }
	    .moveL-leave-to {
	        transform: translateX(-100%);
	    }
		
	    .sanjiaoLeft{
		       width: 1.5em;
		       height: 1.5em;
		       border-top: 1px solid #ccc;
		       border-left: 1px solid #ccc;
		       transform: rotate(315deg);
			   position: absolute;
			   left: 0.5em;
			   right: 0;
			   top:0;
			   bottom: 0;
			   margin:  auto;
	   }	
	   .sanjiaoRight{
	   		       width: 1.5em;
	   		       height: 1.5em;
	   		       border-top: 1px solid #ccc;
	   		       border-left: 1px solid #ccc;
	   		       transform: rotate(135deg);
	   			   position: absolute;
	   			   left: 0;
	   			   right: 0.5em;
	   			   top:0;
	   			   bottom: 0;
	   			   margin:  auto;
	   }	
</style>
